import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import RfpState from 'components/RfpState'
import { RFP_STATE } from '../../../constants'

const MenuItem = styled.div<{ selected: boolean }>`
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  font-weight: bold;
  padding: 15px;

  ${({ selected, theme }) =>
    selected &&
    `
    background: ${theme.colors.backgroundLight};
  `}
`
const Menu = styled.div`
  width: 200px;
`

const states = [
  {
    value: RFP_STATE.PUBLISHED + ',' + RFP_STATE.CLOSED,
    state: RFP_STATE.PUBLISHED,
  },
  { value: RFP_STATE.DRAFT },
  { value: RFP_STATE.FINALIZED },
]

export default function StatesMenu({ selected }: { selected: string }) {
  return (
    <Menu>
      {states.map((state) => (
        <Link key={state.value} to={`?state=${state.value}`}>
          <MenuItem selected={state.value === selected}>
            <RfpState state={state.state || state.value} />
          </MenuItem>
        </Link>
      ))}
    </Menu>
  )
}
